import Text from '@/components/atoms/Text';
import * as S from './styles';
import useBreakpoint from '@/hooks/useBreakpoint';

interface IndiceCadastroUsuarioProps {
  indiceAtual: 1 | 2 | 3;
}

export default function IndiceCadastroUsuario(
  props: IndiceCadastroUsuarioProps,
) {
  const { indiceAtual } = props;
  const { breakpoint } = useBreakpoint();
  return (
    <S.Container $breakpoint={breakpoint}>
      <S.Indice $indiceAtual={indiceAtual === 1}>
        <S.BolinhaIndice />
        <Text
          $size={breakpoint === 'mobile' ? 1 : 2}
          $color="neutral"
          $weight="medium"
          $align="center"
          $highContrast={true}
          $text={`Informações \npessoais`}
          style={{
            whiteSpace: 'pre-line',
            fontSize: 'clamp(10px, 2.5vw, 12px)',
            lineHeight: '1.4',
          }}
        />
      </S.Indice>
      <S.Indice $indiceAtual={indiceAtual === 2}>
        <S.BolinhaIndice />
        <Text
          $size={breakpoint === 'mobile' ? 1 : 2}
          $color="neutral"
          $weight="medium"
          $align="center"
          $highContrast={true}
          $text={`Contato`}
          style={{
            fontSize: 'clamp(10px, 2.5vw, 12px)',
            lineHeight: '1.4',
          }}
        />
      </S.Indice>
      <S.Indice $indiceAtual={indiceAtual === 3}>
        <S.BolinhaIndice />
        <Text
          $size={breakpoint === 'mobile' ? 1 : 2}
          $color="neutral"
          $weight="medium"
          $align="center"
          $highContrast={true}
          $text={`Segurança`}
          style={{
            fontSize: 'clamp(10px, 2.5vw, 12px)',
            lineHeight: '1.4',
          }}
        />
      </S.Indice>
    </S.Container>
  );
}
